import styled from 'styled-components';

import { TextButton } from '@xingternal/button';
import { spaceS, spaceXS } from '@xingternal/tokens';
import { Meta } from '@xingternal/typography';

export const Container = styled.div`
  margin-top: ${spaceS};
`;

export const Text = styled(Meta)`
  display: inline;
`;

export const ResetButton = styled(TextButton)`
  display: inline;
  /* TextButton has a default height */
  height: unset;
  margin-left: ${spaceXS};
`;
